// Module
var code = "<div class=\"col-md-10 col-md-offset-1\">\r\n    <h2>Business disabled</h2>\r\n    <p class=\"lead\">\r\n        The business you are associated with is disabled. Please try again later.\r\n    </p>\r\n    <p>\r\n        <button data-bind=\"click: logout\" class=\"btn btn-primary mt-3\">Logout</button>\r\n    </p>\r\n</div>";
// Exports
export default code;